import { useState, useRef, useCallback } from 'react'

// primul e clipul principal, restul sunt extra (în ordinea de afișare)
const VIDEOS = ['3lvLGq0aLKw', '_zMQWOG96RM', 'UKSTCz5p4Jk', '9KWRJdJhAU8']

// parametri: autoplay pe mut, loop (necesită playlist=ID), fără controale/branding,
// enablejsapi ca să putem trimite comenzi (mute/unMute) prin postMessage
const srcFor = (id) => {
    const params = new URLSearchParams({
        autoplay: '1',
        mute: '1',
        loop: '1',
        playlist: id,
        controls: '0',
        rel: '0',
        modestbranding: '1',
        playsinline: '1',
        iv_load_policy: '3',
        disablekb: '1',
        enablejsapi: '1',
        origin: typeof window !== 'undefined' ? window.location.origin : '',
    })
    return `https://www.youtube-nocookie.com/embed/${id}?${params.toString()}`
}

const Gallery = () => {
    const [i, setI] = useState(0)
    const [muted, setMuted] = useState(true)
    const frame = useRef(null)

    const send = useCallback((func) => {
        const w = frame.current && frame.current.contentWindow
        if (!w) return
        w.postMessage(JSON.stringify({ event: 'command', func, args: [] }), '*')
    }, [])

    const toggle = () => {
        send(muted ? 'unMute' : 'mute')
        send('playVideo')
        setMuted(m => !m)
    }

    // clipul nou pornește mereu pe mut (altfel browserul poate bloca autoplay-ul)
    const pick = (idx) => {
        if (idx === i) return
        setI(idx)
        setMuted(true)
    }

    return (
        <section className="block" id="gallery">
            <div className="wrap">
                <div className="sec-head reveal" style={{ textAlign: 'center', marginInline: 'auto' }}>
                    <span className="eyebrow">Gameplay</span>
                    <h2><span className="grad-text">Sneak</span> Peek</h2>
                    <div className="rule" style={{ marginInline: 'auto' }}></div>
                </div>

                <div className="showcase reveal">
                    <div className="show-stage">
                        <iframe
                            key={VIDEOS[i]}
                            ref={frame}
                            className="show-frame"
                            src={srcFor(VIDEOS[i])}
                            title="Vinewood RP — Sneak Peek"
                            loading="lazy"
                            allow="autoplay; encrypted-media; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                            onLoad={() => {
                                const w = frame.current && frame.current.contentWindow
                                if (w) w.postMessage(JSON.stringify({ event: 'listening' }), '*')
                            }}
                        />
                        <div className="show-shade" />
                        <button
                            className="show-sound"
                            onClick={toggle}
                            aria-label={muted ? 'Pornește sunetul' : 'Oprește sunetul'}
                        >
                            {muted ? '🔇' : '🔊'}
                        </button>
                    </div>

                    <div className="show-thumbs">
                        {VIDEOS.map((id, idx) => (
                            <button
                                key={id}
                                className={'show-thumb' + (idx === i ? ' active' : '')}
                                style={{ backgroundImage: `url(https://i.ytimg.com/vi/${id}/mqdefault.jpg)` }}
                                onClick={() => pick(idx)}
                                aria-label={`Clip ${idx + 1}`}
                                aria-pressed={idx === i}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Gallery
